import ComponentBase from 'components/_base/ComponentBase';
import Utils from 'helpers/Utils';
import CategoriesLayer from '../../layers/CategoriesLayer';
import jQuery from 'jquery';

const CategoriesPanel = ComponentBase.extend({
	template: require('./categoriesPanel.hbs'),
	componentClass: 'mainBox-categories-panel',

	events: {
		'click .melia-categories-container': 'selectCategory'
	},

	constructor(options) {
		ComponentBase.prototype.constructor.call(this, options);
	},
    initialize(options) {
        this._configCategories();
        ComponentBase.prototype.initialize.call(this, options);
        this.setHeight();
        this._listenersEvent();
    },
	_configCategories() {
        this.templateConfig.categories = this.widget.config.categories.map(
            category => {
                if (category.imagePath !== undefined && category.imagePath !== '') {
                    return {
                        catId: category.catId,
                        name: 'categories.' + category.catId,
                        imagePath: Utils.getImgUrl(category.imagePath, this.widget)
                    };
                } else {
                    return {
                        catId: category.catId,
                        name: 'categories.' + category.catId,
                        iconClass: category.iconClass
                    };
                }
            }
        );
	},
    setHeight() {
        const widgetHeight = this.widget.getHeight();
        const heightAutocomplete = 50;
        const marginTopMainPanel = 10;
        const googleLogoHeight = 28;
        const marginBottomMainBoxInMobile = 100;
        if (this.widget.isMobileVersion) {
            this.$el.css(
                'max-height',
                `${widgetHeight - marginBottomMainBoxInMobile - heightAutocomplete}px`
            );
        } else {
            this.$el.css(
                'max-height',
                `${widgetHeight -
                heightAutocomplete -
                marginTopMainPanel -
                googleLogoHeight}px`
            );
        }
    },
    _listenersEvent() {
        this.listenTo(this.bus, 'AUTOCOMPLETE_CATEGORY_SELECTED', item => {
            this.updateLayer(item.catId);
        });
        this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', () => {
            if (this.categoryLayer) {
                this.categoryLayer.remove();
            }
        });
        google.maps.event.addDomListener(this.widget.map, 'resize', () => {
            this.setHeight();
        });
    },
	selectCategory(e) {
		this.updateLayer(e.currentTarget.dataset.categoryid);
		this.parentComponent.caregorySelected(
			jQuery(e.currentTarget)
				.find('.melia-categories-panel-text')
				.text()
		);
        this.bus.trigger('SELECT_RESULT');
	},

	createCategoriesLayer() {
		let listCategoriesClasses = {};
		this.widget.config.categories.forEach(cat => {
			if (cat.iconClass) {
				listCategoriesClasses[cat.catId] = { iconClass: cat.iconClass };
			} else {
				listCategoriesClasses[cat.catId] = {
					imagePath: Utils.getImgUrl(cat.imagePath, this.widget)
				};
			}
		});
		this.categoryLayer = new CategoriesLayer({
			widget: this.widget,
			id: 'CategoriesLayer',
			active: true,
			cleanMarkers: true,
			clickable: false,
			iconMarkerByType: listCategoriesClasses,
			iconMarker: {},
			minZoom: this.widget.config.minZoom
		});
		this.widget.addLayer(this.categoryLayer);
	},

    updateLayer(catId) {
        if (!this.categoryLayer) {
            this.createCategoriesLayer();
        }
        this.categoryLayer.refreshCategory(catId);
    }
});

export default CategoriesPanel;




// WEBPACK FOOTER //
// ./src/components/categoriesPanel/CategoriesPanel.js